/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Usage_Limit_HintInputs */

const en_admin_discounts_usage_limit_hint = /** @type {(inputs: Admin_Discounts_Usage_Limit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum total uses (leave empty for unlimited)`)
};

const de_admin_discounts_usage_limit_hint = /** @type {(inputs: Admin_Discounts_Usage_Limit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von wie vielen Mitgliedern der Code eingelöst werden kann (leer lassen für unbegrenzt)`)
};

const es_admin_discounts_usage_limit_hint = /** @type {(inputs: Admin_Discounts_Usage_Limit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de usos (déjalo en blanco para ilimitado)`)
};

const fr_admin_discounts_usage_limit_hint = /** @type {(inputs: Admin_Discounts_Usage_Limit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre maximal d'utilisations (laisser blanc pour un nombre illimité)`)
};

/** @type {(inputs: Admin_Discounts_Usage_Limit_HintInputs) => LocalizedString} */
const it_admin_discounts_usage_limit_hint = en_admin_discounts_usage_limit_hint;

/** @type {(inputs: Admin_Discounts_Usage_Limit_HintInputs) => LocalizedString} */
const pt_br2_admin_discounts_usage_limit_hint = en_admin_discounts_usage_limit_hint;

/** @type {(inputs: Admin_Discounts_Usage_Limit_HintInputs) => LocalizedString} */
const pl_admin_discounts_usage_limit_hint = en_admin_discounts_usage_limit_hint;

/** @type {(inputs: Admin_Discounts_Usage_Limit_HintInputs) => LocalizedString} */
const hu_admin_discounts_usage_limit_hint = en_admin_discounts_usage_limit_hint;

/** @type {(inputs: Admin_Discounts_Usage_Limit_HintInputs) => LocalizedString} */
const ro_admin_discounts_usage_limit_hint = en_admin_discounts_usage_limit_hint;

/**
* | output |
* | --- |
* | "Maximum total uses (leave empty for unlimited)" |
*
* @param {Admin_Discounts_Usage_Limit_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_usage_limit_hint = /** @type {((inputs?: Admin_Discounts_Usage_Limit_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Usage_Limit_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_usage_limit_hint(inputs)
	if (locale === "de") return de_admin_discounts_usage_limit_hint(inputs)
	if (locale === "es") return es_admin_discounts_usage_limit_hint(inputs)
	if (locale === "fr") return fr_admin_discounts_usage_limit_hint(inputs)
	if (locale === "it") return it_admin_discounts_usage_limit_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_usage_limit_hint(inputs)
	if (locale === "pl") return pl_admin_discounts_usage_limit_hint(inputs)
	if (locale === "hu") return hu_admin_discounts_usage_limit_hint(inputs)
	return ro_admin_discounts_usage_limit_hint(inputs)
});
export { admin_discounts_usage_limit_hint as "admin.discounts.usage_limit_hint" }